import { render, staticRenderFns } from "./DataPrivacyPolicy.vue?vue&type=template&id=1c04fed2&scoped=true"
import script from "./DataPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./DataPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c04fed2",
  null
  
)

export default component.exports